// Depolar Arası Stok Transfer penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.warehouseTransfer';

export const warehouseTransferGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Depolar arası stok transferi nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Bu pencere, bir ürünün stoğunu bir depodan başka bir depoya taşır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Depolar ve ürün listeleri'),
    footer: t(`${G}.regions.footer`, 'Tümünü Aktar / Aktar / Kapat'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu ekran ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Transferde ürün kaynak depodan düşer, hedef depoya eklenir; ürünün toplam stoğu değişmez. Her kayıt bir transfer fişi oluşturur ve Depo Yönetimi sayfasındaki "Transfer Fişleri" sekmesinde görünür.'),
      tips: [
        t(`${G}.s1.tip1`, 'Yanlış bir transferi Transfer Fişleri sekmesinde fişi açıp "İşlemleri Geri Al" ile geri alabilirsiniz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Kaynak ve hedef depoyu seçin'),
      text: t(`${G}.s2.text`, '"Kaynak Depo" stoğun çıkacağı, "Hedef Depo" stoğun gireceği depodur. İkisi aynı depo olamaz. Her deponun yanında Akıllı veya Normal etiketi görünür.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Aktarılacak miktarları girin'),
      text: t(`${G}.s3.text`, '"Kaynak Depo Ürünleri" listesinde yalnız o depoda stoğu olan ürünler görünür. Arama ve kategori ile listeyi daraltın, aktarmak istediğiniz ürünlerin miktar kutusuna miktarı yazın.'),
      tips: [
        t(`${G}.s3.tip1`, 'Girilen miktar, o depodaki mevcut stoktan fazla olamaz.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Ürünleri transfer listesine alın'),
      text: t(`${G}.s4.text`, '"Aktar" girdiğiniz miktarları sağdaki "Transfer Edilecek Ürünler" listesine alır. "Tümünü Aktar" listede o an görünen sayfadaki tüm ürünleri mevcut stoklarının tamamıyla ekler. Bu adımda henüz kayıt yapılmaz.'),
      tips: [
        t(`${G}.s4.tip1`, 'Listede olan bir ürüne yeniden miktar girip "Aktar"a basarsanız miktarı güncellenir; çöp kutusu ürünü listeden çıkarır.'),
        t(`${G}.s4.tip2`, 'Lot takibi olan üründe lotları elle seçerseniz lot miktarlarının toplamı transfer miktarına eşit olmalıdır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Transferi kaydedin'),
      text: t(`${G}.s5.text`, '"Transferi Kaydet" bir onay penceresi açar; depoları ve ürünleri kontrol edip "Transferi Onayla" ile kaydedin. Stok her ürün için ayrıca kontrol edilir: stoğu yetmeyen ürün aktarılmaz, diğerleri aktarılır ve sonuç mesajı pencerenin üstünde görünür.'),
      tips: [
        t(`${G}.s5.tip1`, 'Hedef depo akıllı (WMS) depoysa lokasyonlar otomatik ve rastgele atanır; "Atanan lokasyonlar" penceresi hangi ürünün hangi rafa yazıldığını gösterir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Pencereyi kapatın'),
      text: t(`${G}.s6.text`, '"Kapat" ile çıkın; kaydedilmemiş transfer listesi saklanmaz. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
